import { notification } from 'antd';
import ApiService from 'utils/ApiCalls';

const fetchEntity = async (entityData: any, linkToken: string) => {
  try {
    const response = await ApiService.postEntity(entityData, linkToken);
    notification.success({
      message: 'Info',
      description: 'The entity has been successfully saved.',
      duration: 20,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchEntityNames = async () => {
  try {
    const response = await ApiService.getFiltersByEntity();
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchEntityType = async (entityData: any) => {
  try {
    const response = await ApiService.postEntityType(entityData);
    notification.success({
      message: 'Info',
      description: 'Entity Type - successfuly saved',
      duration: 20,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchHierarchyGroup = async (hierarchyGroupData: any) => {
  try {
    const response = await ApiService.postHierarchyGroup(hierarchyGroupData);
    notification.success({
      message: 'Info',
      description: 'Hierarchy Group - successfuly saved',
      duration: 20,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

const setAllEntities = async () => {
  try {
    const response = await ApiService.getAllEntities();
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchEntityTypeByEntityName = async (entityTypeData: any) => {
  try {
    const response =
      await ApiService.postEntityTypeByEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching Entity Type:', error);
  }
};

const fetchHierarchyGroupByEntityName = async (entityTypeData: any) => {
  try {
    const response =
      await ApiService.postHierarchyGroupByEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching Hierarchy Group:', error);
  }
};

const fetchNatureOfEntityByEntityName = async (entityTypeData: any) => {
  try {
    const response =
      await ApiService.postNatureOfEntityByEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching Nature of Entity:', error);
  }
};

const fetchCompetentAuthorityByEntityName = async (entityTypeData: any) => {
  try {
    const response =
      await ApiService.postCompetentAuthorityByEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching Competent Authority:', error);
  }
};

const fetchCountryByEntityName = async (entityTypeData: any) => {
  try {
    const response = await ApiService.postCountryByEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching Country:', error);
  }
};

const fetchValueOfTotalAssetsByEntityName = async (entityTypeData: any) => {
  try {
    const response =
      await ApiService.postValueOfTotalAssetsByEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching the Value of Total Assets:', error);
  }
};

const fetchActivitiesByEntityName = async (entityTypeData: any) => {
  try {
    const response =
      await ApiService.postActivitiesByEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching the Activities:', error);
  }
};

const fetchEntitiesByEntityName = async (entityTypeData: any) => {
  try {
    const response = await ApiService.postEntitiesByEntityName(entityTypeData);
    return response;
  } catch (error) {
    console.log('Error fetching the Entities:', error);
  }
};

const fetchNatureOfEntity = async (natureOfEntity: any) => {
  try {
    const response = await ApiService.postNatureOfEntity(natureOfEntity);
    notification.success({
      message: 'Info',
      description: 'Nature of Entity - successfuly saved',
      duration: 20,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchCompetentAuthority = async (competentAuthority: any) => {
  try {
    const response =
      await ApiService.postCompetentAuthority(competentAuthority);
    notification.success({
      message: 'Info',
      description: 'Competent authority - successfuly saved',
      duration: 20,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchCountry = async (country: any) => {
  try {
    const response = await ApiService.postCountry(country);
    notification.success({
      message: 'Info',
      description: 'Country - successfuly saved',
      duration: 20,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchValueOfTotalAssets = async (valueOfTotalAssets: any) => {
  try {
    const response =
      await ApiService.postValueOfTotalAssets(valueOfTotalAssets);
    notification.success({
      message: 'Info',
      description: 'Value of Total Assets - successfuly saved',
      duration: 20,
    });
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchActivitiesByTypeEntity = async (activitiesByTypeEntity: any) => {
  try {
    const response = await ApiService.postActivitiesByTypeEntity(
      activitiesByTypeEntity,
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchEntityTypes = async () => {
  try {
    const response = await ApiService.getEntityTypes();
    return response;
  } catch (error) {
    console.log('Error fetching the entity types:', error);
  }
};

const fetchHierarchyInGroup = async () => {
  try {
    const response = await ApiService.getHierarchyInGroups();
    return response;
  } catch (error) {
    console.log('Error fetching the Hierarchy in groups api:', error);
  }
};

const fetchNatureID = async () => {
  try {
    const response = await ApiService.getNatureID();
    return response;
  } catch (error) {
    console.log('Error fetching the nature id api:', error);
  }
};

const fetchCompetentAuthorities = async () => {
  try {
    const response = await ApiService.getCompetentAuthorities();
    return response;
  } catch (error) {
    console.log('Error fetching the competent authorities api:', error);
  }
};

const fetchCurrencies = async () => {
  try {
    const response = await ApiService.getCurrencies();
    return response;
  } catch (error) {
    console.log('Error fetching currencies api:', error);
  }
};

const fetchCountries = async () => {
  try {
    const response = await ApiService.getCountries();
    return response;
  } catch (error) {
    console.log('Error fetching countries api:', error);
  }
};

const fetchBranches = async () => {
  try {
    const response = await ApiService.getListOfBranches();
    return response;
  } catch (error) {
    console.log('Error fetching branches api:', error);
  }
};

const fetchAllFinancialEntities = async () => {
  try {
    const response = await ApiService.getFinancialEntities();
    return response;
  } catch (error) {
    console.log(error);
  }
};

const fetchFinancialEntitiesById = async (
  financial_entity_id: number | null,
) => {
  try {
    const response =
      await ApiService.getFinancialEntityById(financial_entity_id);
    return response;
  } catch (error) {
    console.log('Error fetching the Financial Entities:', error);
  }
};

const fetchFinancialEntity = async (entityData: any) => {
  try {
    const response = await ApiService.postFinancialEntity(entityData);
    notification.success({
      message: 'Info',
      description: 'The financial entity has been successfully saved.',
      duration: 20,
    });
    return response;
  } catch (error: any) {
    notification.error({
      message: 'Info',
      description: error.errors.message,
      duration: 20,
    });
    console.log(error);
  }
};

const filterEntitybyFinancialEntities = async (
  financial_entity_lei_id: number,
) => {
  try {
    const response = await ApiService.filterEntitybyFinancialEntities(
      financial_entity_lei_id,
    );
    return response;
  } catch (error) {
    console.log('Error fetching branches api:', error);
  }
};

export default {
  fetchEntity,
  fetchEntityType,
  fetchHierarchyGroup,
  setAllEntities,
  fetchEntityTypeByEntityName,
  fetchHierarchyGroupByEntityName,
  fetchNatureOfEntityByEntityName,
  fetchCompetentAuthorityByEntityName,
  fetchCountryByEntityName,
  fetchValueOfTotalAssetsByEntityName,
  fetchActivitiesByEntityName,
  fetchEntitiesByEntityName,
  fetchNatureOfEntity,
  fetchCompetentAuthority,
  fetchCountry,
  fetchValueOfTotalAssets,
  fetchActivitiesByTypeEntity,
  fetchEntityTypes,
  fetchHierarchyInGroup,
  fetchNatureID,
  fetchCompetentAuthorities,
  fetchCurrencies,
  fetchCountries,
  fetchEntityNames,
  fetchBranches,
  fetchAllFinancialEntities,
  fetchFinancialEntitiesById,
  fetchFinancialEntity,
  filterEntitybyFinancialEntities,
};
